import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './PDCSelector.module.css';
import { CancelButton, ApplyButton, DBDropDown, DBDropDownPDC, DBDropDownPDCWeight } from '_components';
import { Modal } from 'react-bootstrap'


class PatientCareCenterNoteSubjectivePDCSelector extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            warningVisible: false,
            warningType: undefined,
            column: undefined,
            value: undefined,
            newPdc: undefined,
            deleteReason: undefined
        };
    }

    computePdc(lift, liftFreq) {
        let key = Object.keys(this.props.pdcLookup)
            .find(x =>
                this.props.pdcLookup[x].WFXDWNO === lift
                && this.props.pdcLookup[x].WFXDWFNO === liftFreq
            );

        return key ? this.props.pdcLookup[key].WFXWPNO : undefined;
    }

    handleJobReqChange(event) {
        let jrLift = this.props.dolJobReqLift;
        let jrLiftFreq = this.props.dolJobReqLiftFreq;

        let tempColumn = undefined;
        let tempValue = undefined;

        switch (event.target.name) {
            case this.props.prefix + 'SUBWCDOLJOBREQLIFT':
                jrLift = parseInt(event.target.value);
                tempColumn = this.props.prefix + 'SUBWCDOLJOBREQLIFT';
                tempValue = jrLift;
                break;
            case this.props.prefix + 'SUBWCDOLJOBREQLIFTFREQ':
                jrLiftFreq = parseInt(event.target.value);
                tempColumn = this.props.prefix + 'SUBWCDOLJOBREQLIFTFREQ';
                tempValue = jrLiftFreq;
                break;
            default:
                break;
        }

        let pdc = this.computePdc(jrLift, jrLiftFreq);

        if (this.props.jobReqPdc !== undefined && pdc !== undefined && this.props.jobReqPdc.WPNO !== pdc) {
            if (this.props.hasGoals) {
                this.setState({
                    warningVisible: true,
                    warningType: 'set',
                    column: tempColumn,
                    value: tempValue,
                    newPdc: pdc
                });
                event.stopPropagation();
            } else {
                this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCJOBREQPDC', pdc)
            }
        } else if (this.props.jobReqPdc !== undefined && pdc === undefined) {
            if (this.props.hasGoals) {
                this.setState({
                    warningVisible: true,
                    warningType: 'clear',
                    column: tempColumn,
                    value: tempValue,
                    newPdc: pdc
                });
                event.stopPropagation();
            } else {
                this.props.clearField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCJOBREQPDC')
            }
        } else if (this.props.jobReqPdc === undefined && pdc !== undefined) {
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCJOBREQPDC', pdc)
        }
    }

    handleCurrentChange(event) {
        let curLift = this.props.dolCurrentLift;
        let curLiftFreq = this.props.dolCurrentLiftFreq;

        switch (event.target.name) {
            case this.props.prefix + 'SUBWCDOLCURRENTLIFT':
                curLift = parseInt(event.target.value);
                break;
            case this.props.prefix + 'SUBWCDOLCURRENTLIFTFREQ':
                this.props.clearField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCDOLCURRENTLIFT')
                curLiftFreq = parseInt(event.target.value);
                break;
            default:
                break;
        }


        let pdc = this.computePdc(curLift, curLiftFreq);

        if (this.props.currentPdc !== undefined && pdc !== undefined && this.props.currentPdc.WPNO !== pdc) {
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCCURRENTPDC', pdc)
        } else if (this.props.currentPdc !== undefined && pdc === undefined) {
            this.props.clearField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCCURRENTPDC')
        } else if (this.props.currentPdc === undefined && pdc !== undefined) {
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCCURRENTPDC', pdc)
        }
    }

    confirmPdcChange() {
        if (this.state.warningType === 'set') {
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.state.column, this.state.value);
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCJOBREQPDC', this.state.newPdc);
        } else if (this.state.warningType === 'clear') {
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.state.column, this.state.value);
            this.props.clearField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCJOBREQPDC');
        }

        if (this.state.column === this.props.prefix + 'SUBWCDOLJOBREQLIFTFREQ') {
            this.props.clearField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCDOLJOBREQLIFT')
        }


        this.props.clearGoals(this.props.noteId, 'PDC Level Changed: ' + this.state.deleteReason);
        this.setState({
            warningVisible: false,
            warningType: undefined,
            column: undefined,
            value: undefined,
            newPdc: undefined,
            deleteReason: undefined
        });
    }

    cancel() {
        this.setState({
            warningVisible: false,
            warningType: undefined,
            column: undefined,
            value: undefined,
            newPdc: undefined,
            deleteReason: undefined
        });
    }

    handleDeleteReasonChange(event) {
        this.setState({
            deleteReason: event.target.value
        });
    }

    render() {
        return (
            <div>
                {this.state.warningVisible &&
                    <Modal show={true} backdrop='static' keyboard={false} dialogClassName={styles.dialog}>
                        <div className={styles.title}>Work Comp PDC Warning</div>
                        <div className={styles.description}>
                            WARNING - You are about to change the PDC level for this
                            patient.  All of the current goals will be DELETED and
                            new goals will be required.  Provide a reason for this
                            change in the space below:
                        </div>
                        <div className={styles.reason_wrapper}>
                            <textarea name="pdcChangeReason" type="text" className={styles.reason} rows="6" value={this.state.deleteReason} onChange={(event) => this.handleDeleteReasonChange(event)} />
                        </div>
                        <div className={styles.buttons}>
                            <span className={styles.button_wrapper}>
                                <ApplyButton size='small' title='Confirm PDC Change' onClick={() => this.confirmPdcChange()} />
                            </span>
                            <span className={styles.button_wrapper}>
                                <CancelButton size='small' title='Cancel' onClick={() => this.cancel()} />
                            </span>
                        </div>
                    </Modal>

                }

                {this.props.noteType === 1 &&
                    <PatientCareCenterNoteSection id='subj_wc_job_req_pdc' name='Job Required PDC Analysis' level={2} allowCollapse={false} >
                        <div className={styles.row}>
                            <label className={styles.wide_col}>How much time is the patient required to <b>stand</b> at their job:</label>
                            <span className={styles.leftover_col}>
                                <DBDropDownPDC
                                    className={styles.drop_down}
                                    noteId={this.props.noteId}
                                    entity={this.props.table}
                                    entityKeyColumn={this.props.prefix + 'NO'}
                                    entityKeyValue={this.props.pk}
                                    field={this.props.prefix + 'SUBWCJOBREQSTAND'}
                                    isCurrent={false}
                                />
                            </span>
                        </div>
                        <div className={styles.row}>
                            <label className={styles.wide_col}>How much time is the patient required to <b>walk</b> at their job:</label>
                            <span className={styles.leftover_col}>
                                <DBDropDownPDC
                                    className={styles.drop_down}
                                    noteId={this.props.noteId}
                                    entity={this.props.table}
                                    entityKeyColumn={this.props.prefix + 'NO'}
                                    entityKeyValue={this.props.pk}
                                    field={this.props.prefix + 'SUBWCJOBREQWALK'}
                                    isCurrent={false}
                                />
                            </span>
                        </div>
                        <div className={styles.row}>
                            <label className={this.props.noteType === 4 ? styles.wide_col : styles.wide_col_req}>Job required <b>lift</b> frequency:</label>
                            <span className={styles.leftover_col}>
                                <DBDropDown
                                    className={styles.drop_down}
                                    noteId={this.props.noteId}
                                    entity={this.props.table}
                                    entityKeyColumn={this.props.prefix + 'NO'}
                                    entityKeyValue={this.props.pk}
                                    field={this.props.prefix + 'SUBWCDOLJOBREQLIFTFREQ'}
                                    masterEntity='PTMASTERWCDOLPDCWEIGHTFREQ'
                                    masterEntityKeyColumn='DWFNO'
                                    masterEntitySort='DWFORDER'
                                    masterEntityDisplay='DWFNAME'
                                    onChange={event => this.handleJobReqChange(event)}
                                />
                            </span>
                        </div>
                        <div className={styles.row}>
                            <label className={this.props.noteType === 4 ? styles.wide_col : styles.wide_col_req}>How much weight is the patient required to <b>lift</b> at their job:</label>
                            <span className={styles.leftover_col}>
                                <DBDropDownPDCWeight
                                    className={styles.drop_down}
                                    noteId={this.props.noteId}
                                    entity={this.props.table}
                                    entityKeyColumn={this.props.prefix + 'NO'}
                                    entityKeyValue={this.props.pk}
                                    field={this.props.prefix + 'SUBWCDOLJOBREQLIFT'}
                                    masterField={this.props.prefix + 'SUBWCDOLJOBREQLIFTFREQ'}
                                    onChange={event => this.handleJobReqChange(event)}
                                />
                            </span>
                        </div>
                        <div className={styles.row}>
                            <label className={styles.wide_col}>Job Req. PDC:</label>
                            <span className={styles.leftover_col}>
                                {this.props.jobReqPdc ? this.props.jobReqPdc.WPNAME : ''}
                            </span>
                        </div>
                    </PatientCareCenterNoteSection>
                }
                <PatientCareCenterNoteSection id='subj_wc_current_pdc' name='Current PDC Analysis' level={2} allowCollapse={false} >
                    <div className={styles.row}>
                        <label className={styles.wide_col}>How much time is the patient currently able to <b>stand</b>:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDownPDC
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCCURRENTSTAND'}
                                isCurrent={true}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={styles.wide_col}>How much time is the patient currently able to <b>walk</b>:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDownPDC
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCCURRENTWALK'}
                                isCurrent={true}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={this.props.noteType === 2 ? styles.wide_col : styles.wide_col_req}>Current <b>lift</b> frequency:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDown
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCDOLCURRENTLIFTFREQ'}
                                masterEntity='PTMASTERWCDOLPDCWEIGHTFREQ'
                                masterEntityKeyColumn='DWFNO'
                                masterEntitySort='DWFORDER'
                                masterEntityDisplay='DWFNAME'
                                onChange={event => this.handleCurrentChange(event)}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={this.props.noteType === 2 ? styles.wide_col : styles.wide_col_req}>How much weight is the patient currently able to <b>lift</b>:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDownPDCWeight
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCDOLCURRENTLIFT'}
                                masterField={this.props.prefix + 'SUBWCDOLCURRENTLIFTFREQ'}
                                onChange={event => this.handleCurrentChange(event)}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={styles.wide_col}>Current PDC:</label>
                        <span className={styles.leftover_col}>
                            {this.props.currentPdc ? this.props.currentPdc.WPNAME : ''}
                        </span>
                    </div>
                </PatientCareCenterNoteSection>


            </div>
        );
    }

}


function mapDispatchToProps(dispatch) {
    return {
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        clearGoals: bindActionCreators(noteActions.clearGoals, dispatch)
    };
}


function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);

    let hasGoals = Object.keys(state.entities.notes.PTGOALS)
        .filter(key => {
            return ((noteType === 1 && state.entities.notes.PTGOALS[key].GOEVNO === pk) ||
                (noteType !== 1 && state.entities.notes.PTGOALS[key].GONTNO === pk)) &&
                state.entities.notes.PTGOALS[key].GODELETED !== true
        })
        .map(key => state.entities.notes.PTGOALS[key]).length ? true : false;

    let dolJobReqLift = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCDOLJOBREQLIFT :
        state.entities.notes.PTNOTE[pk].NTSUBWCDOLJOBREQLIFT;
    let dolJobReqLiftFreq = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCDOLJOBREQLIFTFREQ :
        state.entities.notes.PTNOTE[pk].NTSUBWCDOLJOBREQLIFTFREQ;

    let dolCurrentLift = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCDOLCURRENTLIFT :
        state.entities.notes.PTNOTE[pk].NTSUBWCDOLCURRENTLIFT;
    let dolCurrentLiftFreq = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCDOLCURRENTLIFTFREQ :
        state.entities.notes.PTNOTE[pk].NTSUBWCDOLCURRENTLIFTFREQ;

    let jrPDC = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQPDC :
        state.entities.notes.PTNOTE[pk].NTSUBWCJOBREQPDC;
    let curPDC = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCCURRENTPDC :
        state.entities.notes.PTNOTE[pk].NTSUBWCCURRENTPDC;

    return {
        noteId,
        noteType,
        pk,
        dolJobReqLift,
        dolJobReqLiftFreq,
        dolCurrentLift,
        dolCurrentLiftFreq,
        pdcLookup: state.entities.masterData.PTMASTERWCDOLPDCWEIGHTFREQXREF,
        jobReqPdc: state.entities.masterData.PTMASTERWCPDC[jrPDC],
        currentPdc: state.entities.masterData.PTMASTERWCPDC[curPDC],
        hasGoals,
        prefix: noteType === 1 ? "EV" : "NT",
        table: noteType === 1 ? "PTEVAL" : "PTNOTE"
    };
}

const connectedPatientCareCenterNoteSubjectivePDCSelector = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSubjectivePDCSelector);
export { connectedPatientCareCenterNoteSubjectivePDCSelector as PatientCareCenterNoteSubjectivePDCSelector };

